module.exports = __webpack_public_path__ + "static/media/Connections.13b4ad19.svg";